import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../../../Axiosinstance';
import { TextField, Button, Grid,IconButton,  CircularProgress, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, MenuItem, Box, Divider } from '@mui/material';
import { CheckCircleOutline, CloudUpload } from '@mui/icons-material';
import { CLOUDINARY_UPLOAD_PRESET, baseURL } from '../../../common';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import PhoneInput from 'react-phone-input-2';

const SelfSponsoredForm = ({ fee }) => {
  const { batchid } = useParams(); // Extract batchid from URL params
  const [openModal, setOpenModal] = useState(false);
  const [registerId, setRegisterId] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    sector: '',
    name: '',
    idType: '',
    nric: '',
    dob: '',
    emailId: [''],
    contactNumber: [''],
    cardType: '',
    fee: fee,
    promotionCode: '',
    registration_Form: '',
    ic: '',
    supporting_Documents: ''
  });

  const handleSearchSubmit = async () => {
    const nricValue = formData.nric;
    if (!nricValue) {
      toast.error('Please enter an NRIC number to search.', { position: toast.POSITION.TOP_RIGHT });
      return;
    }

    try {
      const response = await axios.get(`/wsq/companies/get-by-nric?nric=${nricValue}`);
      if (response.status === 200 && response.data) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          ...response.data // Populate form fields with response data
        }));
        toast.success('Data retrieved successfully!', { position: toast.POSITION.TOP_RIGHT });
      } else {
        toast.error('No data available for the entered NRIC.', { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (error) {
      toast.error('Error retrieving data. Please try again.', { position: toast.POSITION.TOP_RIGHT });
      console.error('Search error:', error);
    }
  };

  const handleFileChange = (e, fieldName) => {
    handleFileUpload(e, 0, 0, fieldName); // Assuming single student for now
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleArrayChange = (field, index, value) => {
    const updatedArray = [...formData[field]];
    updatedArray[index] = value;
    setFormData({ ...formData, [field]: updatedArray });
  };

  const addArrayItem = (field) => {
    setFormData({ ...formData, [field]: [...formData[field], ''] });
  };

  const removeArrayItem = (field, index) => {
    const updatedArray = formData[field].filter((_, i) => i !== index);
    setFormData({ ...formData, [field]: updatedArray });
  };

  const handleFileUpload = async (e, contactIndex, studentIndex, fieldName) => {
    try {
      const file = e.target.files[0];
      if (!file) return;
  
      const formDataUpload = new FormData();
      formDataUpload.append('file', file);
      formDataUpload.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
  
      const response = await fetch(baseURL, {
        method: 'POST',
        body: formDataUpload,
      });
  
      const data = await response.json();
  
      if (data.secure_url) {
        const uploadedFileUrl = data.secure_url;
  
        setFormData((prevState) => ({
          ...prevState,
          [fieldName]: uploadedFileUrl,
        }));
      }
    } catch (err) {
      console.error('File upload error:', err);
    }
  };

  const handleCloseModal = () => {
    // Reset form data and other states
    setFormData({
      sector: '',
      name: '',
      idType: 'NRIC',
      nric: '',
      dob: '',
      emailId: [''],
    contactNumber: [''],
      cardType: '',
      fee: fee,
      promotionCode: '',
      registration_Form: '',
      ic: '',
      supporting_Documents: ''
    });
    setRegisterId('');
    setOpenModal(false);
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const payload = {
      sector: formData.sector , // Default updated values
      name: formData.name ,
      idType: formData.idType ,
      dob: formData.dob ,
      registration_Form: formData.registration_Form ,
      supporting_Documents: formData.supporting_Documents ,
      ic: formData.ic ,
      emailId: formData.emailId ,
      contactNumber: formData.contactNumber ,
      cardType: formData.cardType ,
      fee: formData.fee || 500,
      promotionCode: formData.promotionCode ,
      batchId: batchid ,  // batchid comes from URL params
    };
  
    setLoading(true);
    
    try {
      const response = await axios.put(`/wsq/companies/update-by-nric/${formData.nric}`, payload); // Use dynamic NRIC
      if (response.status === 200) {
        setRegisterId(response.data.registerId);
        setOpenModal(true);
      }
    } catch (error) {
      toast.error('Error submitting the form. Please try again.', { position: toast.POSITION.TOP_RIGHT });
      console.error('Error submitting form:', error);
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Box mb={2}>
          <Grid container spacing={2}>
            <Grid item xs={10}>
              <TextField
                label="Search by NRIC"
                name="nric"
                variant="outlined"
                fullWidth
                value={formData.nric}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={2}>
              <Button variant="contained" color="primary" onClick={handleSearchSubmit}>
                Search
              </Button>
            </Grid>
          </Grid>
        </Box>
        <Divider />

        {/* Other form fields */}
        <TextField
          label="Sector"
          name="sector"
          variant="outlined"
          fullWidth
          margin="normal"
          required
          value={formData.sector}
          onChange={handleChange}
        />
        <TextField
          label="Full Name (As per NRIC)"
          name="name"
          variant="outlined"
          fullWidth
          margin="normal"
          required
          value={formData.name}
          onChange={handleChange}
        />
        <TextField
          label="ID Type"
          name="idType"
          select
          variant="outlined"
          fullWidth
          margin="normal"
          required
          value={formData.idType}
          onChange={handleChange}
        >
          <MenuItem value="NRIC">NRIC</MenuItem>
          <MenuItem value="FIN">FIN</MenuItem>
          <MenuItem value="Passport">Passport</MenuItem>
        </TextField>
        <TextField
          label={formData.idType || "ID"}
          name="nric"
          variant="outlined"
          fullWidth
          margin="normal"
          required
          value={formData.nric}
          onChange={handleChange}
        />
        <TextField
          label="Date of Birth"
          name="dob"
          type="date"
          variant="outlined"
          fullWidth
          margin="normal"
          required
          InputLabelProps={{
            shrink: true,
          }}
          value={formData.dob}
          onChange={handleChange}
        />
        <div>
      <Typography variant="h6" gutterBottom>
        Email Addresses
      </Typography>
      {formData.emailId.map((email, index) => (
        <Grid container alignItems="center" spacing={1} key={`email-${index}`} style={{ marginBottom: '10px' }}>
          {/* Email Input */}
          <Grid item xs={10}>
            <TextField
              label="Email"
              type="email"
              variant="outlined"
              fullWidth
              required
              value={email}
              onChange={(e) => handleArrayChange('emailId', index, e.target.value)}
            />
          </Grid>

          {/* Add Button */}
          <Grid>
            <IconButton color="primary" onClick={() => addArrayItem('emailId')}>
              <AddCircleOutlineIcon />
            </IconButton>
          </Grid>

          {/* Remove Button */}
          <Grid>
            {index > 0 && (
              <IconButton color="error" onClick={() => removeArrayItem('emailId', index)}>
                <RemoveCircleOutlineIcon />
              </IconButton>
            )}
          </Grid>
        </Grid>
      ))}

      <Typography variant="h6" gutterBottom>
        Contact Numbers
      </Typography>
      {formData.contactNumber.map((contactNumber, index) => (
        <Grid container alignItems="center" spacing={1} key={`contact-${index}`} style={{ marginBottom: '10px' }}>
          {/* Phone Input */}
          <Grid item xs={10}>
            <PhoneInput
              country={'sg'} // Default country code
              value={contactNumber}
              onChange={(value, country) =>
                handleArrayChange(
                  'contactNumber',
                  index,
                  `+${country.dialCode} ${value.slice(country.dialCode.length)}`
                )
              }
              inputStyle={{
                width: '100%',
                height: '56px', // Match Material-UI TextField height
                borderRadius: '4px',
              }}
            />
          </Grid>

          {/* Add Button */}
          <Grid>
            <IconButton color="primary" onClick={() => addArrayItem('contactNumber')}>
              <AddCircleOutlineIcon />
            </IconButton>
          </Grid>

          {/* Remove Button */}
          <Grid>
            {index > 0 && (
              <IconButton color="error" onClick={() => removeArrayItem('contactNumber', index)}>
                <RemoveCircleOutlineIcon />
              </IconButton>
            )}
          </Grid>
        </Grid>
      ))}
    </div>
        <TextField
          label="Card Type"
          name="cardType"
          variant="outlined"
          fullWidth
          margin="normal"
          required
          value={formData.cardType}
          onChange={handleChange}
        />

        {/* File upload fields */}
        <Typography variant="h6" gutterBottom>Upload Documents:</Typography>
        <Grid container spacing={2}>
  {/* Registration Form Upload */}
  <Grid item xs={12}>
    <Button
      variant="contained"
      component="label"
      fullWidth
      startIcon={<CloudUpload />}
      sx={{ backgroundColor: '#1976d2', color: '#fff', marginBottom: '10px' }}
    >
      Upload Registration Form
      <input
        type="file"
        hidden
        accept=".pdf,.jpg,.png"
        onChange={(e) => handleFileChange(e, 'registration_Form')}
      />
    </Button>
    {formData.registration_Form ? (
      <>
        <Typography variant="body2" color="textSecondary">
          Selected file: {formData.registration_Form.split('/').pop()}
        </Typography>
        {/* Debugging log */}
        {console.log("Registration Form URL:", formData.registration_Form)}
        {/* Render preview for images or PDFs */}
        {formData.registration_Form.endsWith('.jpg') || formData.registration_Form.endsWith('.png') ? (
          <img src={formData.registration_Form} alt="Preview" style={{ width: '100%', maxHeight: '300px', objectFit: 'contain', marginTop: '10px' }} />
        ) : formData.registration_Form.endsWith('.pdf') ? (
          <embed
            src={formData.registration_Form}
            type="application/pdf"
            width="100%"
            height="500px"
            style={{ marginTop: '10px' }}
          />
        ) : (
          <Typography variant="body2" color="error">
            Unsupported file type
          </Typography>
        )}
      </>
    ) : (
      <Typography variant="body2" color="textSecondary">
        No file uploaded yet.
      </Typography>
    )}
  </Grid>

  {/* IC Upload */}
  <Grid item xs={12}>
    <Button
      variant="contained"
      component="label"
      fullWidth
      startIcon={<CloudUpload />}
      sx={{ backgroundColor: '#1976d2', color: '#fff', marginBottom: '10px' }}
    >
      Upload IC
      <input
        type="file"
        hidden
        accept=".pdf,.jpg,.png"
        onChange={(e) => handleFileChange(e, 'ic')}
      />
    </Button>
    {formData.ic ? (
      <>
        <Typography variant="body2" color="textSecondary">
          Selected file: {formData.ic.split('/').pop()}
        </Typography>
        {/* Debugging log */}
        {console.log("IC URL:", formData.ic)}
        {/* Render preview for images or PDFs */}
        {formData.ic.endsWith('.jpg') || formData.ic.endsWith('.png') ? (
          <img src={formData.ic} alt="Preview" style={{ width: '100%', maxHeight: '300px', objectFit: 'contain', marginTop: '10px' }} />
        ) : formData.ic.endsWith('.pdf') ? (
          <embed
            src={formData.ic}
            type="application/pdf"
            width="100%"
            height="500px"
            style={{ marginTop: '10px' }}
          />
        ) : (
          <Typography variant="body2" color="error">
            Unsupported file type
          </Typography>
        )}
      </>
    ) : (
      <Typography variant="body2" color="textSecondary">
        No file uploaded yet.
      </Typography>
    )}
  </Grid>

  {/* Supporting Documents Upload */}
  <Grid item xs={12}>
    <Button
      variant="contained"
      component="label"
      fullWidth
      startIcon={<CloudUpload />}
      sx={{ backgroundColor: '#1976d2', color: '#fff', marginBottom: '10px' }}
    >
      Upload Supporting Documents
      <input
        type="file"
        hidden
        accept=".pdf,.jpg,.png"
        onChange={(e) => handleFileChange(e, 'supporting_Documents')}
      />
    </Button>
    {formData.supporting_Documents ? (
      <>
        <Typography variant="body2" color="textSecondary">
          Selected file: {formData.supporting_Documents.split('/').pop()}
        </Typography>
        {/* Debugging log */}
        {console.log("Supporting Documents URL:", formData.supporting_Documents)}
        {/* Render preview for images or PDFs */}
        {formData.supporting_Documents.endsWith('.jpg') || formData.supporting_Documents.endsWith('.png') ? (
          <img src={formData.supporting_Documents} alt="Preview" style={{ width: '100%', maxHeight: '300px', objectFit: 'contain', marginTop: '10px' }} />
        ) : formData.supporting_Documents.endsWith('.pdf') ? (
          <embed
            src={formData.supporting_Documents}
            type="application/pdf"
            width="100%"
            height="500px"
            style={{ marginTop: '10px' }}
          />
        ) : (
          <Typography variant="body2" color="error">
            Unsupported file type
          </Typography>
        )}
      </>
    ) : (
      <Typography variant="body2" color="textSecondary">
        No file uploaded yet.
      </Typography>
    )}
  </Grid>
</Grid>


        <Typography variant="h6" gutterBottom>
          Course Amount: SGD ${fee} (EXCL. GST)
        </Typography>
        <TextField
          label="Promotion Code"
          name="promotionCode"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.promotionCode}
          onChange={handleChange}
        />
        
        {/* Submit Button */}
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          disabled={loading}
          sx={{ marginTop: '20px' }}
        >
          {loading ? <CircularProgress size={24} /> : 'Submit'}
        </Button>
      </form>

      {/* Modal */}
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogTitle>Registration Successful</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your registration was successful. Your register ID is {registerId}.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
  <Button onClick={handleCloseModal} color="primary">
    Close
  </Button>
</DialogActions>

      </Dialog>
    </div>
  );
};

export default SelfSponsoredForm;
